import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { TransformedNoContentOption } from '@flows/core/types/stepContentTypes'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_Drone } from '@flows/insurance/schemas'

const DRONES_NUMBER_OPTIONS: TransformedNoContentOption[] = [
  {
    label: {
      type: 'translatableText',
      translationKey: 'sharedFlows_drone:steps.numberOfDrones.one',
    },
    value: '1',
  },
  {
    label: {
      type: 'translatableText',
      translationKey: 'sharedFlows_drone:steps.numberOfDrones.two_to_five',
    },
    value: '2-5',
  },
  {
    label: {
      type: 'translatableText',
      translationKey: 'sharedFlows_drone:steps.numberOfDrones.more_than_five',
    },
    value: 'more_than_five',
  },
]

const number_of_drones = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getHelperPath('number_of_drones')]:
        BaseSchema_Drone.shape.number_of_drones.unwrap(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_drone:steps.numberOfDrones.title',
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getHelperPath('number_of_drones'),
        options: DRONES_NUMBER_OPTIONS,
      },
    ],
    nextStep: 'drone_weight',
    subFlow: params.subFlow,
  }) as const satisfies AnyStepConfiguration

export default number_of_drones
